"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import type { ApiDrop } from "@/generated/models/ObjectSerializer";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistSubmissionBadge } from "@/components/waves/drops/ArtistSubmissionBadge";
import { ProfileWinnerBadge } from "@/components/waves/drops/ProfileWinnerBadge";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
interface SingleWaveDropAuthorProps {
  readonly drop: ApiDrop;
}
export const SingleWaveDropAuthor: React.FC<SingleWaveDropAuthorProps> = t0 => {
  const $ = _c(39);
  const {
    drop
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInitialTab, setModalInitialTab] = useState("active");
  const submissionCount = drop.author.active_main_stage_submission_ids?.length || 0;
  const hasSubmissions = submissionCount > 0;
  const winnerCount = drop.author.winner_main_stage_drop_ids?.length || 0;
  const isWinner = winnerCount > 0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = tab => {
      setModalInitialTab(tab);
      setIsModalOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleBadgeClick = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleModalClose = t2;
  const t3 = `/${drop.author.handle}`;
  let t4;
  if ($[2] !== drop.author.pfp) {
    t4 = drop.author.pfp ? <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950 tw-overflow-hidden"><img className="tw-size-full tw-object-contain tw-opacity-90" src={drop.author.pfp} alt="User avatar" /></div> : <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-iron-900" />;
    $[2] = drop.author.pfp;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = drop.author.handle ?? drop.author.id;
  let t6;
  if ($[4] !== drop.author.handle) {
    t6 = <span className="tw-text-md tw-font-semibold tw-text-white desktop-hover:hover:tw-text-opacity-80">{drop.author.handle}</span>;
    $[4] = drop.author.handle;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <UserProfileTooltipWrapper user={t5}>{t6}</UserProfileTooltipWrapper>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== drop.author.level) {
    t8 = <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[9] = drop.author.level;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <div className="tw-inline-flex tw-items-center tw-gap-x-1">{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== drop.id || $[15] !== isWinner || $[16] !== winnerCount) {
    t10 = isWinner && <ProfileWinnerBadge winCount={winnerCount} onBadgeClick={() => handleBadgeClick("winners")} tooltipId={`single-drop-winner-badge-${drop.id}`} />;
    $[14] = drop.id;
    $[15] = isWinner;
    $[16] = winnerCount;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== drop.id || $[19] !== hasSubmissions || $[20] !== submissionCount) {
    t11 = hasSubmissions && <ArtistSubmissionBadge submissionCount={submissionCount} onBadgeClick={() => handleBadgeClick("active")} tooltipId={`single-drop-badge-${drop.id}`} />;
    $[18] = drop.id;
    $[19] = hasSubmissions;
    $[20] = submissionCount;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <div className="tw-inline-flex tw-items-center tw-gap-x-1">{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t9) {
    t13 = <div className="tw-inline-flex tw-items-center tw-gap-x-2">{t9}{t12}</div>;
    $[25] = t12;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t3 || $[30] !== t4) {
    t14 = <div className="tw-flex tw-items-start tw-gap-x-2.5"><Link href={t3} className="tw-flex tw-items-center tw-gap-x-2.5 tw-no-underline">{t4}{t13}</Link></div>;
    $[28] = t13;
    $[29] = t3;
    $[30] = t4;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== drop.author || $[33] !== isModalOpen || $[34] !== modalInitialTab) {
    t15 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} initialTab={modalInitialTab} />;
    $[32] = drop.author;
    $[33] = isModalOpen;
    $[34] = modalInitialTab;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t14 || $[37] !== t15) {
    t16 = <>{t14}{t15}</>;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};